/*# sourceMappingURL=tab-panel.component-LM75OZXW.css.map */
